<template lang="html">
  <section class="app-sidebar">
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <ul class="nav">
        <li class="nav-item nav-profile">
          <div class="nav-link">
            <div class="user-wrapper">
              <div class="profile-image"> 
                <img src="../../assets/images/faces/face4.jpg" alt="image"/> 
              </div>
              <div class="profile-name">
                <p class="name">{{ restaurantOwnerName }}</p>
                <div>
                  <small class="designation text-muted">Restaurant Owner</small>
                  <span class="status-indicator online"></span>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li class="nav-item">
          <router-link class="nav-link" to="/">
            <i class="menu-icon mdi mdi-television"></i>
            <span class="menu-title">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/ordermessages">
            <i class="menu-icon mdi mdi-view-dashboard"></i>
            <span class="menu-title">Orders Control</span>
          </router-link>
        </li>
        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'restaurants'">
            <i class="menu-icon mdi mdi-store"></i>
            <span class="menu-title">Restaurants</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse id="restaurants">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/restauranteditform/">Restaurant Detail</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/openingtimes/">OpeningTimes</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/delivery/">Delivery Configuration</router-link></li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'inventory'">
            <i class="menu-icon mdi mdi-bank"></i>
            <span class="menu-title">Inventory</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse id="inventory">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/categories/">Categories</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/items/">Items</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/menus">Menus</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/taxes">Taxes</router-link></li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/">
            <i class="menu-icon mdi mdi-account"></i>
            <span class="menu-title">Customers</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/orders">
            <i class="menu-icon mdi mdi-receipt"></i>
            <span class="menu-title">Orders</span>
          </router-link>
        </li>
        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'settings'">
            <i class="menu-icon mdi mdi-settings"></i>
            <span class="menu-title">Settings</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse id="settings">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/printer/">Printer</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/payment/">Payment</router-link></li>
            </ul>
          </b-collapse>
        </li>
      </ul>
    </nav>
  </section>

</template>

<script lang="js">
import { mapState } from'vuex'
import JQuery from 'jquery'
let $ = JQuery
export default {
  name: 'app-sidebar',
  computed: {
    ...mapState({
      restaurantOwnerName: state => state.login.restaurantOwnerName,
      phoneNumber: state => state.login.phoneNumber })
  },
  methods: {
    
  },
  mounted () {
    $('.sidebar-icon-only .sidebar .nav .nav-item').on('mouseenter', function () {
      var $this = $(this)
      $this.addClass('hover-open')
      $this.find('.nav-link').addClass('hover-open')
    })
    $('.sidebar-icon-only .sidebar .nav .nav-item').on('mouseleave', function () {
      var $this = $(this)
      $this.removeClass('hover-open')
      $this.find('.nav-link').removeClass('hover-open')
    })
  }
}
</script>

<style scoped lang="scss">
.app-sidebar {
}
</style>
